import { secondAxios } from "../../../../../../api/axios";

// Get fabrications by project ID (legacy endpoint for backward compatibility)
export const getFabrication = async (projectId) => {
  const response = await secondAxios.get(`/fabrication/${projectId}`);
  console.log("fabrication response", response.data);
  return response.data;
};

// Get fabrications by plant ID
export const getFabricationByPlant = async (plantId) => {
  const response = await secondAxios.get(`/fabrication/plant/${plantId}`);
  console.log("fabrication response (plant)", response.data);
  return response.data;
};

// Create fabrication - supports both project and plant
// If isPlant is true, parentId is treated as plantId, otherwise as projectId
export const createFabrication = async (parentId, fabrication, isPlant = false) => {
  console.log(fabrication);
  
  if (isPlant && parentId) {
    // Create fabrication for plant
    // Ensure plantId is included in the DTO
    const fabricationWithPlantId = {
      ...fabrication,
      plantId: parentId,
    };
    await secondAxios.post(`/fabrication/plant/${parentId}`, [fabricationWithPlantId]);
  } else if (parentId) {
    // Create fabrication for project (legacy endpoint)
    await secondAxios.post(`/fabrication/${parentId}`, fabrication);
  } else {
    // Fallback: use POST /fabrication with plantId or projectId in DTO
    const fabricationWithParent = {
      ...fabrication,
      ...(isPlant ? { plantId: parentId } : { projectId: parentId }),
    };
    await secondAxios.post(`/fabrication`, fabricationWithParent);
  }
};

// Create bulk fabrications - supports both project and plant
export const createBulkFabrication = async (parentId, fabrications, isPlant = false) => {
  console.log(parentId, fabrications);
  
  if (isPlant && parentId) {
    // Create fabrications for plant
    const fabricationsWithPlantId = Array.isArray(fabrications)
      ? fabrications.map((fab) => ({ ...fab, plantId: parentId }))
      : [{ ...fabrications, plantId: parentId }];
    await secondAxios.post(`/fabrication/plant/${parentId}`, fabricationsWithPlantId);
  } else if (parentId) {
    // Create fabrications for project (legacy endpoint)
    await secondAxios.post(`/fabrication/${parentId}`, fabrications);
  } else {
    // Fallback: use POST /fabrication with plantId or projectId in DTO
    const fabricationsWithParent = Array.isArray(fabrications)
      ? fabrications.map((fab) => ({
          ...fab,
          ...(isPlant ? { plantId: parentId } : { projectId: parentId }),
        }))
      : {
          ...fabrications,
          ...(isPlant ? { plantId: parentId } : { projectId: parentId }),
        };
    await secondAxios.post(`/fabrication`, fabricationsWithParent);
  }
};

export const updateFabrication = async (fabrication) => {
  console.log({ fabrication });
  await secondAxios.patch(`/fabrication/${fabrication.id}`, fabrication);
};

export const deleteFabrication = async (fabricationId) => {
  await secondAxios.delete(`/fabrication/${fabricationId}`);
};
